module.exports = function (done, value) {
  return { value: value, done: !!done };
};



//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-react-next/~/core-js/modules/_iter-step.js
// module id = ./node_modules/gatsby-plugin-react-next/node_modules/core-js/modules/_iter-step.js
// module chunks = 168707334958949